<template>
  <pt-customer-sample-list class="pt-customer-sample-list__page"></pt-customer-sample-list>
</template>

<script>
import PtCustomerSampleList from 'cps/gene-product/pt-customer-sample-list/withData'
export default {
  name: 'pt-customer-sample-list__view',
  components: {
    'pt-customer-sample-list': PtCustomerSampleList
  }
}
</script>
